/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ngx-bootstrap/alert/alert.component';
import * as i3 from 'ngx-bootstrap/alert/alert.config';
const styles_AlertComponent:any[] = ([] as any[]);
export const RenderType_AlertComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AlertComponent,data:{}});
function View_AlertComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n      '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),7,'button',[['aria-label','Close'],['class','close'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.close()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['×'])),(_l()(),i0.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i0.ɵeld(6,0,(null as any),(null as any),1,'span',[['class','sr-only']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Close'])),(_l()(),i0.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i0.ɵted(-1,(null as any),['\n    ']))],(null as any),
      (null as any));
}
function View_AlertComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),7,'div',[['role','alert']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i0.ɵdid(2,278528,(null as any),0,
      i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],
      {klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),(_l()(),i0.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_AlertComponent_2)),i0.ɵdid(5,16384,(null as any),0,i1.NgIf,
      [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i0.ɵted(-1,(null as any),['\n    '])),i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,
      (null as any),['\n  '])),(_l()(),i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = ('alert alert-' + _co.type);
    const currVal_1:any = _co.classes;
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_2:any = _co.dismissible;
    _ck(_v,5,0,currVal_2);
  },(null as any));
}
export function View_AlertComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_AlertComponent_1)),i0.ɵdid(2,
      16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,
      _v) => {
    var _co:i2.AlertComponent = _v.component;
    const currVal_0:boolean = !_co.isClosed;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_AlertComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'alert',([] as any[]),
      (null as any),(null as any),(null as any),View_AlertComponent_0,RenderType_AlertComponent)),
      i0.ɵdid(1,114688,(null as any),0,i2.AlertComponent,[i3.AlertConfig],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AlertComponentNgFactory:i0.ComponentFactory<i2.AlertComponent> = i0.ɵccf('alert,ngx-alert',
    i2.AlertComponent,View_AlertComponent_Host_0,{type:'type',dismissible:'dismissible',
        dismissOnTimeout:'dismissOnTimeout'},{onClose:'onClose',onClosed:'onClosed'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL2FsZXJ0L2FsZXJ0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9hbGVydC9hbGVydC5jb21wb25lbnQuZC50cyIsIm5nOi8vL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL2FsZXJ0L2FsZXJ0LmNvbXBvbmVudC5kLnRzLkFsZXJ0Q29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9hbGVydC9hbGVydC5jb21wb25lbnQuZC50cy5BbGVydENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuPHRlbXBsYXRlIFtuZ0lmXT1cIiFpc0Nsb3NlZFwiPlxuICA8ZGl2IFtjbGFzc109XCInYWxlcnQgYWxlcnQtJyArIHR5cGVcIiByb2xlPVwiYWxlcnRcIiBbbmdDbGFzc109XCJjbGFzc2VzXCI+XG4gICAgPHRlbXBsYXRlIFtuZ0lmXT1cImRpc21pc3NpYmxlXCI+XG4gICAgICA8YnV0dG9uIHR5cGU9XCJidXR0b25cIiBjbGFzcz1cImNsb3NlXCIgYXJpYS1sYWJlbD1cIkNsb3NlXCIgKGNsaWNrKT1cImNsb3NlKClcIj5cbiAgICAgICAgPHNwYW4gYXJpYS1oaWRkZW49XCJ0cnVlXCI+JnRpbWVzOzwvc3Bhbj5cbiAgICAgICAgPHNwYW4gY2xhc3M9XCJzci1vbmx5XCI+Q2xvc2U8L3NwYW4+XG4gICAgICA8L2J1dHRvbj5cbiAgICA8L3RlbXBsYXRlPlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgPC9kaXY+XG48L3RlbXBsYXRlPlxuICAiLCI8YWxlcnQ+PC9hbGVydD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0dtQyxnREFDN0I7TUFBQTtVQUFBO1FBQUE7UUFBQTtRQUF1RDtVQUFBO1VBQUE7UUFBQTtRQUF2RDtNQUFBLGdDQUF5RTtNQUN2RTtVQUFBO01BQXlCLHlDQUFjO01BQ3ZDO1VBQUE7TUFBc0IsNkNBQVk7VUFBQSxlQUMzQjs7OztvQkFOYyw0Q0FDM0I7TUFBQTtNQUFBLG1EQUFBO2lCQUFBO01BQUEseURBQXNFO01BQUEsMkJBQ3BFO01BQUEsK0NBQUE7TUFBQSxzRUFLVzthQUFBLHNDQUNYLGtCQUF5QjtNQUFBLHlCQUNyQjs7SUFSRDtJQUE2QztJQUFsRCxXQUFLLFVBQTZDLFNBQWxEO0lBQ1k7SUFBVixXQUFVLFNBQVY7Ozs7b0JBSEosMENBQ0E7TUFBQSwyRUFBQTtNQUFBO1VBQUEsd0JBVVc7OztJQVZEO0lBQVYsV0FBVSxTQUFWOzs7O29CQ0RBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/node_modules/ngx-bootstrap/alert/alert.component.ngfactory.ts